import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Slider } from '@/components/ui/slider';
import { Pause, Play } from 'lucide-react';
import { useGlobalBackgroundAudio } from '@/contexts/BackgroundAudioContext';

// Minimal floating controls to satisfy autoplay policies and allow volume control
const BackgroundAudioControls: React.FC = () => {
  const {
    playBackgroundAudio,
    pauseBackgroundAudio,
    backgroundVolume,
    updateBackgroundVolume,
    isBackgroundReady,
    isBackgroundPlaying
  } = useGlobalBackgroundAudio();

  const handleTogglePlay = async () => {
    try {
      if (isBackgroundPlaying) {
        pauseBackgroundAudio();
      } else {
        await playBackgroundAudio();
      }
    } catch (e) {
      console.error('BackgroundAudioControls: play/pause failed', e);
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="rounded-lg shadow-lg bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60 border">
        <div className="flex items-center gap-3 p-3">
          <Button size="sm" variant="secondary" onClick={handleTogglePlay} disabled={!isBackgroundReady} aria-label={isBackgroundPlaying ? 'Pause background music' : 'Play background music'}>
            {isBackgroundPlaying ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}
          </Button>
          <div className="w-32">
            <Slider
              value={[Math.round(backgroundVolume * 100)]}
              max={100}
              step={1}
              onValueChange={(val) => updateBackgroundVolume((val[0] ?? 0) / 100)}
              aria-label="Background volume"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackgroundAudioControls;
